<div class="app">
  <div class="app__inner" [class.anim--in]="loading$()">
    <a class="skiplink" (click)="skipToContent($event)" href="#main-content">Ga naar inhoud</a>

    @if (loaded$()) {
      <app-topbar
        (toggleOverlay)="toggleMenu()"
        (closeOverlay)="closeMenu()"
        (openOverlay)="openMenu()"
        [menuActive]="menuOpen$()"
        [menu]="('main-menu' | fromMenu)?.error ? [] : ('main-menu' | fromMenu)"
      ></app-topbar>
    }

    <div class="app__router" id="main-content" tabindex="-1">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>

    @if (loaded$() && !outlet.activatedRouteData?.['hideFooter']) {
      <app-footer
        [domain]="domainName"
        [socials]="socials$()"
        [metaMenu]="('footer-meta-menu' | fromMenu)?.error ? [] : ('footer-meta-menu' | fromMenu)"
      ></app-footer>
    }

    @if (loaded$()) {
      <fstr-cookie-notice
        [title]="'cookie:titel' | fromDictionary"
        [text]="'cookie:tekst' | fromDictionary"
        [buttonAccept]="'cookie:accepteer-knop-tekst' | fromDictionary"
        [buttonReject]="'cookie:afwijzen-knop-tekst' | fromDictionary"
      ></fstr-cookie-notice>
    }
  </div>

  <app-loader-indicator [loading]="loading$()"></app-loader-indicator>
</div>

@if (testGridEnabled) {
  <app-grid-overlay></app-grid-overlay>
}

<!--@if (showSnowOverlay()) {
  <app-snow-overlay-physics [debug]="debug()" />
}

<app-christmas-toggle [initial]="showSnowOverlay()"></app-christmas-toggle>-->
